import React, { useMemo } from "react";
import AsyncSelect from "react-select/async";
import instance from "../../Interceptor/api_instance";
import debounce from "lodash.debounce";
import { customStyles } from "../Utility/ReactSelectStyles";
import { useTranslation } from "react-i18next";

const LocationSearch = ({ onSelect, selectedOption, styles = customStyles}) => {
  const {t} = useTranslation();
  const filterOptions = async (inputValue) => {
    if (!inputValue || inputValue.length < 1) return [];

    try {
      const res = await instance.get(`assets/locations?name=${inputValue}`);
      return res.data.map((option) => ({
        value: option.id,
        label: option.loc_name,
      }));
    } catch (err) {
      console.error("Failed to fetch list: ", err);
      return [];
    }
  };

  // ✅ Debounce filterOptions and return a wrapped function that resolves a Promise
  const debouncedLoadOptions = useMemo(() => {
    const wrapped = debounce((inputValue, callback) => {
      filterOptions(inputValue).then(callback);
    }, 1000); // 500ms debounce

    return (inputValue) =>
      new Promise((resolve) => wrapped(inputValue, resolve));
  }, []);

  return (
    <AsyncSelect
      cacheOptions
      aria-label="Location"
      inputId="location-select"
      name="location"
      defaultOptions={false}
      loadingMessage={() => t("general.loading")}
      loadOptions={debouncedLoadOptions}
      onChange={(option) => onSelect(option)}
      placeholder={t("yard-tables.table-columns.location")}
      noOptionsMessage={() => t("forms.type.vehicle.search.visitor.not-found")}
      isClearable
      className="search-select"
      styles={styles}
      unstyled={true}
      value={selectedOption}
      required
    />
  );
};

export default React.memo(LocationSearch);